import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { Banner, Card } from '../components/ui';

export function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="auth-wrap"><span className="faint">Loading…</span></div>;
  if (user) return <Navigate to={location.state?.from ?? '/admin'} replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email, password);
      navigate(location.state?.from ?? '/admin', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="brand" style={{ marginBottom: 18, justifyContent: 'center' }}>
          <span className="dot" />
          <span>
            IAM Testbench
            <small>SAML · OAuth · PingAccess</small>
          </span>
        </div>
        <Card>
          <form onSubmit={submit}>
            {error && <Banner kind="error">{error}</Banner>}
            <label className="field">
              <span>Email</span>
              <input
                type="email" value={email} autoComplete="username" autoFocus required
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="field">
              <span>Password</span>
              <input
                type="password" value={password} autoComplete="current-password" required
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </Card>
        <p className="faint small" style={{ textAlign: 'center' }}>
          Local accounts only — deliberately independent of any external IdP, so you can still
          sign in while the identity provider you are testing is broken.
        </p>
      </div>
    </div>
  );
}
